module.exports = __webpack_public_path__ + "img/sports_middle.22db671d.jpg";